<template>
  <header class="shadow-w-screen">
    <nav class="flex items-center justify-between flex-wrap bg-green-400 p-6">
      <div class="flex items-center flex-shrink-0 text-white mr-6">
        <px-icon class="mr-2" />
        <router-link
          class="font-semibold text-xl tracking-tight"
          :to="{ name: 'home' }"
          >Exchange App</router-link
        >
        <router-link to="/about" class="text-white text-md tracking-tight px-2"
          >About</router-link
        >
      </div>
      <div
        class="hidden sm:block w-full block flex-grow lg:flex lg:items-center lg:w-auto"
      >
        <div class="text-sm lg:flex-grow">
          <router-link
            v-for="link in links"
            :key="link.title"
            :to="link.to"
            class="block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-white mr-4"
            >{{ link.title }}</router-link
          >
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import PxIcon from "@/components/PxIcon";

export default {
  name: "PxHeader",
  components: { PxIcon },

  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
